<template>
    <div>
        <div class="footer">
            <div class="footer_m column">
                <div class="footer_m_t row">
                    <div class="footer_m_t_l column">
                        <div class="footer_m_t_l_t row">
                            <!-- <div class="footer_m_t_l_t_m">
                                <div class="footer_m_t_l_t_m_title">企业服务</div>
                                <a class="footer_m_t_l_t_m_text" href="">职位搜索</a>
                                <a class="footer_m_t_l_t_m_text">新闻资讯</a>
                                <a class="footer_m_t_l_t_m_text">职远速聘APP</a>
                                <a class="footer_m_t_l_t_m_text">投资者关系 Investor Relations</a>
                                <a class="footer_m_t_l_t_m_text">直品公益基金会</a>
                            </div> -->
                            <div class="footer_m_t_l_t_m">
                                <div class="footer_m_t_l_t_m_title">使用与帮助</div>
                                <a href="https://www.zhiyuansupin.com/contract/agreement.html" target="_blank"
                                    class="footer_m_t_l_t_m_text">用户协议</a>
                                <a href="https://www.zhiyuansupin.com/contract/privacy.html" target="_blank"
                                    class="footer_m_t_l_t_m_text">隐私政策</a>
                                <!-- <a class="footer_m_t_l_t_m_text">防骗指南</a> -->
                                <!-- <a class="footer_m_t_l_t_m_text">使用帮助</a> -->
                            </div>
                            <div class="footer_m_t_l_f_m">
                                <div class="footer_m_t_l_t_m_title">联系职远速聘</div>
                                <a class="footer_m_t_l_t_m_text">上海麦星企业管理咨询有限公司</a>
                                <a class="footer_m_t_l_t_m_text">公司地址 上海市松江区中创路68号</a>
                                <a class="footer_m_t_l_t_m_text">违法和不良信息举报邮箱/未成年人举报渠道 pr@zhiyuansupin.com</a>
                            </div>
                        </div>
                        <div class="footer_m_t_l_f">
                            <span>Copyright © 2024</span>
                            <span>职远速聘 <a href="https://beian.miit.gov.cn/" target="_blank"
                                    style="font-size: 12px;">沪ICP备2021036158号-1</a></span>
                            <span><a @click="tiaozhuan('/license')">电子营业执照</a></span>
                            <!-- <span>京公网安备11010502032801</span> -->
                            <!-- <span><a>朝阳网警</a></span> -->
                            <span><a @click="tiaozhuan('/permit')">人力资源服务许可证</a></span>
                            <!-- <span><a>网上有害信息举报专区</a></span> -->
                            <!-- <span><a>朝阳区人社局监督电话</a></span> -->
                            <!-- <span><a>算法备案信息</a></span> -->
                        </div>
                    </div>
                    <div class="footer_m_t_r column">
                        <div class="footer_m_t_r_title">职远速聘</div>
                        <!-- <div class="footer_m_t_r_text">企业服务热线和算法/未成年人等举报渠道</div>
                        <div class="footer_m_t_r_text">老年人直连热线400 661 6030</div>
                        <div class="footer_m_t_r_text">工作日 8:00 - 22:00</div>
                        <div class="footer_m_t_r_text">休息日 8:00 - 22:00</div> -->
                        <img src="@/assets/images/erweima.png" style="width: 100px; height: 100px; ">
                    </div>
                </div>

            </div>
            <!-- <div class="footer_m_f">
                <div class="footer_m_f_m row">
                    <div class="footer_m_f_title">友情链接：</div>
                    <div class="footer_m_f_r">
                        <span><a >店长直聘</a></span>
                        <span><a >留学生招聘</a></span>
                        <span><a >北京招聘</a></span>
                        <span><a >上海招聘</a></span>
                        <span><a >广州招聘</a></span>
                        <span><a >深圳招聘</a></span>
                        <span><a >杭州招聘</a></span>
                        <span><a >天津招聘</a></span>
                        <span><a >西安招聘</a></span>
                        <span><a >苏州招聘</a></span>
                        <span><a >成都招聘</a></span>
                        <span><a >郑州招聘</a></span>
                        <span><a >重庆招聘</a></span>
                        <span><a >合肥招聘</a></span>
                        <span><a >兼职</a></span>
                        <span><a >风入松书店</a></span>
                        <span><a >offerToday</a></span>
                        <span><a >天眼查</a></span>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
export default {
    name: 'LaFooter',
    components: {},
    data() {
        return {

        }
    },
    mounted() {

    },
    activated() {

    },
    methods: {
        tiaozhuan(val) {
            this.$router.push(val);
        },
    }

}
</script>

<style scoped>
.footer {
    width: 100%;
    height: auto;
    background: #313438;
    padding: 20px 0 20px;
    margin-top: 43px;
}

.footer_m {
    width: 1200px;
    height: auto;
    margin: auto;
}

.footer_m_t {
    justify-content: space-between;
}

.footer_m_t_l {
    flex: 1;
}

.footer_m_t_l_t_m {
    width: 200px;
    float: left;
}

.footer_m_t_l_t_m_title {
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    margin-bottom: 10px;
    color: rgba(255, 255, 255, .8);
}

.footer_m_t_l_t_m_text {
    display: block;
    color: rgba(255, 255, 255, .5);
    width: 100%;
    font-size: 12px;
    height: 24px;
    line-height: 24px;
}

.footer_m_t_l_t_m_text:hover {
    color: #00b277;
}

.footer_m_t_l_f_m {
    float: left;
}

.footer_m_t_l_f {
    margin: 20px 0 10px;
}

.footer_m_t_l_f>span {
    margin-right: 20px;
    font-size: 14px;
    height: 24px;
    line-height: 24px;
    color: rgba(255, 255, 255, .5);
    display: inline-block;
}

.footer_m_t_r_title {
    width: 100%;
    height: 30px;
    line-height: 30px;
    font-size: 16px;
    font-weight: bolder;
    margin-bottom: 10px;
    color: rgba(255, 255, 255, .8);
    text-align: right;
}

.footer_m_t_r_text {
    display: block;
    color: rgba(255, 255, 255, .5);
    width: 100%;
    font-size: 12px;
    height: 24px;
    line-height: 24px;
    text-align: right;
}

.footer_m_f {
    border-top: 1px solid #46494c;
    padding: 7px 0 6px 0;
}

.footer_m_f_m {
    width: 1200px;
    height: auto;
    margin: auto;
}

.footer_m_f_r>span {
    margin-right: 20px;
    font-size: 12px;
    height: 24px;
    line-height: 24px;
    color: rgba(255, 255, 255, .5);
    display: inline-block;
}

.footer_m_f_title {
    width: 100px;
    font-size: 12px;
    display: inline;
    height: 24px;
    line-height: 24px;
    color: rgba(255, 255, 255, .5);
}
</style>
